const secondary = {
    social_bind_with: 'Ai deja un cont? Autentifică-te pentru a lega {{methods, list(type: disjunction;)}} de identitatea ta socială.',
};
export default Object.freeze(secondary);
